import { useEffect, useMemo, useRef } from 'react';
import { t } from 'i18next';
import { ReactComponent as BlueArrowRightIcon } from '../../icons/blue.arrow.right.svg';
import type { PayLetterPaymentMethod } from '../../domains/orders/services/orderServices';
import PayLetterPaymentMethodSelector from './components/PayLetterPaymentMethodSelector';
import { usePayLetterPayment } from './hooks/usePayLetterPayment';

const PayLetterPaymentLaunchPage = () => {
  const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);

  const amount = searchParams.get('amount') ?? '';
  const productName = searchParams.get('productName') ?? '';
  const productId = searchParams.get('productId') ?? '';
  const paymentMethod = searchParams.get('paymentMethod') as PayLetterPaymentMethod | null;
  const autoPay = searchParams.get('autoPay') === 'true';
  const hasAutoRequestedRef = useRef(false);

  const { handleCreateOrder, isSubmitting } = usePayLetterPayment({
    amount,
    productName,
    productId,
    autoPay
  });

  useEffect(() => {
    if (!productId || !amount || !productName) return;
    if (!paymentMethod && !autoPay) return;
    if (hasAutoRequestedRef.current) return;
    hasAutoRequestedRef.current = true;
    void handleCreateOrder(paymentMethod ?? undefined);
  }, [amount, autoPay, handleCreateOrder, paymentMethod, productId, productName]);

  if (paymentMethod || autoPay) {
    return (
      <div className="min-h-screen flex flex-col gap-[38px] items-center justify-center">
        <BlueArrowRightIcon width={65} height={65} />
        <p className="text-[24px] font-semibold text-text-main-lv2 leading-[28px] text-center">
          {t('InicisPaymentLaunch.moveToPayment')}
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-[24px] py-[32px]">
      <div className="w-full max-w-[420px] flex flex-col gap-[20px] items-center">
        <BlueArrowRightIcon width={56} height={56} />
        <p className="text-[22px] font-semibold text-text-main-lv2 leading-[28px] text-center">
          {t('InicisPaymentLaunch.moveToPayment')}
        </p>
        <p className="text-[14px] text-text-sub-lv1 text-center">
          결제수단을 선택해주세요.
        </p>
      </div>
      <PayLetterPaymentMethodSelector
        isOpen={true}
        isSubmitting={isSubmitting}
        onClose={() => window.close()}
        onSelect={(method) => void handleCreateOrder(method)}
      />
    </div>
  );
};

export default PayLetterPaymentLaunchPage;
